import { Spinner } from '../../components'
import React from 'react'

const Loading = () => <Spinner color="blue" loading size={20} type="BeatLoader" />

export default Loading
